import { IActive } from '../interfaces';

export const active: IActive[] = [
  { label: 'Activo', value: true },
  { label: 'Inactivo', value: false },
];
